/*
 * LicenseSure
 * https://licensesure.biz
 *
 * LicenseSure about name component.
 */

// Core dependencies
import React from "react";

// App dependencies
import Markdown from "../markdown/markdown";

// Styles
import { name } from "./name.module.css";

class Name extends React.Component {
  render() {
    const { children } = this.props;
    return <Markdown className={name}>{children}</Markdown>;
  }
}

export default Name;
